import { render, staticRenderFns } from "./SurveySuggestion.vue?vue&type=template&id=30ebf1d3&scoped=true&"
import script from "./SurveySuggestion.vue?vue&type=script&lang=js&"
export * from "./SurveySuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveySuggestion.vue?vue&type=style&index=0&id=30ebf1d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ebf1d3",
  null
  
)

export default component.exports